'use strict';

export default {
    regions: [],
    popular: [],
    top: ['GB'],
    fetching: false,
    fetched: false,

    /**
     * Get the regions
     */
    getRegions() {
        if (!this.fetched) {
            this.fetched = true;
            this.refresh();
        }
        return this.regions;
    },

    getPopular() {
        if (!this.fetched) {
            this.fetched = true;
            this.refresh();
        }
        return this.popular;
    },

    /**
     * Refresh the region list
     */
    refresh() {
        this.fetching = true;

        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url: '/api/countries',
                headers: {
                    'Accept': 'application/json'
                }
            })
            .then(response => {

                var regions = [];
                _.each(response.data, region => {
                    region.countries = _.filter(region.countries, country => {
                        if (this.top.includes(country.iso_a_2)) {
                            this.popular.push(country);
                            return false;
                        }
                        return true;
                    });
                    regions.push(region);
                });
                this.regions = regions;

                this.fetched = true;
                this.fetching = false;

                resolve(response.data);
            }).catch(errors => {
                this.error = true;
            });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/Country.js